import { stepPersonalAccidentSCTILookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const personalAccidentExpenses = mapToPersonalAccident(data);
  return [...personalAccidentExpenses];
}

function mapToPersonalAccident(data) {
  let claimCode = expenseLookup.isThisClaimRelatedToPersonalAccident.claimCode;
  const expenses = [];
  if (data.isThisClaimRelatedToPersonalAccident === 'true' && data.infoClaimRelatedToPersonalAccidentItems.length > 0) {
    data.infoClaimRelatedToPersonalAccidentItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.isThisClaimRelatedToLossOfLifeCausedByAnInjury === 'true' && data.infoClaimRelatedToLossOfLifeItems.length > 0) {
    claimCode = expenseLookup.isThisClaimRelatedToLossOfLifeCausedByAnInjury.claimCode;
    data.infoClaimRelatedToLossOfLifeItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.didTheInjuryLeaveYouPermanentlyDisabled === 'true' && data.infoDidTheInjuryLeaveYouPermanentlyDisabledItems.length > 0) {
    claimCode = expenseLookup.didTheInjuryLeaveYouPermanentlyDisabled.claimCode;
    data.infoDidTheInjuryLeaveYouPermanentlyDisabledItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.didTheInjuryResultInYourInabilityToReturnToWork === 'true' && data.infoYourInabilityToReturnToWorkItems.length > 0) {
    claimCode = expenseLookup.didTheInjuryResultInYourInabilityToReturnToWork.claimCode;
    data.infoYourInabilityToReturnToWorkItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  return expenses;
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountCreditedOrRefunded || !item.currencyCreditedOrRefunded || item.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem} (Reimbursement)`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: `${item.amountCreditedOrRefunded * -1}`,
    currency: item.currencyCreditedOrRefunded,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPersonalAccidentSCTIDataMapper.js